export const MEDICAID_QUALIFICATION_MONTHS = 60;
